<!--
 * @Description:
 * @Author: YY
 * @LastEditors: sunluhua 1057254519@qq.com
 * @LastEditTime: 2025-03-04 15:51:13
-->
<!--
  @author:chen.hao
  @time:2018/10/11
  @disc:由我审批
 -->

<template>
  <div class="approval-for-me" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="70px">
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="form.type">
          <el-option
            v-for="item in typeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审批标题" prop="auditName">
        <el-input v-model="form.auditName" placeholder="请输入审批标题"></el-input>
      </el-form-item>
      <el-form-item label="发起时间" prop="createTime">
        <el-date-picker
          v-model="form.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeTabs" @tab-click="onTypesChange">
      <el-tab-pane name="1" label="协议类型"></el-tab-pane>
      <el-tab-pane name="2" label="其他类型"></el-tab-pane>
      <el-tab-pane name="3" label="信用授信"></el-tab-pane>
    </el-tabs>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="type"
        label="审批类型"
        width="180"
        :formatter="formatType">
      </el-table-column>
      <el-table-column
        prop="title"
        label="审批标题"
        width="300"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="agreementCode"
        label="协议编号"
        width="180"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="发起时间"
        width="150px">
      </el-table-column>
      <el-table-column
        prop="approvalPerson"
        label="审核人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="approvalTime"
        label="审核时间"
        width="150px">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatStatus">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button v-if="showReviewBtn(scope.row)" @click="review(scope.row)" v-permission="typeToCode(scope.row)">审批</el-button>
          <!-- <el-button v-if="showReviewBtn(scope.row)" @click="review(scope.row)">审批</el-button> -->
          <el-button v-else @click="view(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <info-or-review-dialog :show.sync="dialog.show" :info="dialog.info" :review="dialog.review"></info-or-review-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InfoOrReviewDialog from '../infoOrReviewDialog/index'
import mapApprovalStatus from '../approvalStatus'

export default {
  name: 'approvalForMe',
  components: { InfoOrReviewDialog },
  data () {
    return {
      statusArr: [
        { value: '', label: '全部' },
        ...Object.keys(mapApprovalStatus).map(item => ({
          value: item,
          label: mapApprovalStatus[item]
        }))
      ],
      typeArr: [
        { value: '', label: '全部' },
        { value: 1, label: '营销活动' },
        { value: 2, label: '协议新增' },
        { value: 3, label: '政策' },
        { value: 5, label: '价目管理' },
        { value: 6, label: '资金账户调整' },
        { value: 7, label: '保证金扣减' },
        { value: 8, label: '信用授信' },
        { value: 9, label: '协议变更' },
        { value: 10, label: '运价管理' },
        { value: 11, label: '政策变更' },
        { value: 19, label: '订货会模板' },
        { value: 24, label: '新能源终端销售计划新增' },
        { value: 25, label: '新能源终端销售计划编辑' },
        { value: 26, label: '新能源终端销售计划追加商品' },
        { value: 30, label: '价量合一审批' },
        { value: 41, label: '返优惠产生规则' },
        { value: 42, label: '返优惠使用规则' },
        { value: 43, label: '返优惠审批单' },
        { value: 44, label: '返优惠调整' },
        { value: 28, label: '区域调整' },
        { value: 45, label: '挂牌价配置' },
        { value: 46, label: '挂牌价审核' },
        { value: 47, label: '差异化返利产生规则' },
        { value: 48, label: '差异化返利使用规则' },
        { value: 49, label: '差异化返利审批单' },
        { value: 50, label: '差异化返利账户调整' },
        { value: 51, label: '思达睿终端销售计划新增' },
        { value: 52, label: '库存调整单' },
        { value: 59, label: '即时优惠使用规则' },
        { value: 70, label: '客户申诉' },
        { value: 66, label: '主子账号资金分配' },
        { value: 57, label: '乙醇客户提货量管控' },
        { value: 58, label: '认证手机号重复审批' },
        { value: 60, label: '认证手机号重复经理审批' },
        { value: 56, label: '新增返利账户' },
        { value: 71, label: '检验罐号审批' }
      ],
      form: {
        status: '',
        type: '',
        auditName: '',
        createTime: ''
      },
      dialog: {
        info: '',
        review: false,
        show: false
      },
      activeTabs: '1'
    }
  },
  computed: {
    ...mapGetters({ list: 'getApprovalForMeList', listState: 'getApprovalForMeListState' })
  },
  methods: {
    ...mapActions([
      'getApprovalForMeList',
      'getApprovalInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, listType: parseInt(this.activeTabs), pageNo: 1 }
      this.getApprovalForMeList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getApprovalForMeList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getApprovalForMeList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    onTypesChange () {
      this.handleSearch()
    },
    // 格式化状态
    formatStatus (row) {
      return mapApprovalStatus[row.status]
    },
    // 格式化类型
    formatType (row) {
      const status = this.$lodash.find(this.typeArr, { value: row.type }) || {}
      return status.label
    },
    // 审核
    review (row) {
      this.getApprovalInfo({ auditId: row.id })
        .then(res => {
          console.log(res)
          this.dialog = {
            info: res || {},
            show: true,
            review: true
          }
        })
    },
    // 查看
    view (row) {
      this.getApprovalInfo({ auditId: row.id })
        .then(res => {
          this.dialog = {
            info: res || {},
            show: true,
            review: false
          }
        })
    },
    // 是否显示审批按钮
    showReviewBtn (row) {
      // 未审批状态才能进行审批
      // 协议相关审批不在后台进行操作（临时方案，后续删除后台由我审批模块）
      // 除了价目管理、运价管理、政策管理、运价管理、政策变更、订货会模板 其他都走钉钉审批
      const allowTypeArr = [1, 3, 5, 8, 10, 11, 19, 24, 25, 26, 30, 41, 42, 43, 44, 28, 45, 46, 47, 48, 50, 51, 52, 56, 57, 58, 60, 59, 70, 66, 71]
      if (row.type === 45) {
        if (row.approvalAuthorityYN === 1 && (row.status === 1 || row.status === 2)) {
          return true
        } else {
          return false
        }
      }
      // todo
      return row.status === 1 && !!allowTypeArr.find(item => item === row.type)
    },
    // 不同审批类型权限
    typeToCode (row) {
      const map = {
        1: '0110208',
        2: '0110206',
        3: '0110205',
        5: '0110201',
        6: '0110202',
        7: '0110203',
        8: '0110204',
        9: '0110207',
        10: '0110209',
        11: '0110210',
        19: '0110211',
        24: '0110212',
        25: '0110213',
        26: '0110214',
        30: '0110230',
        41: '0110216',
        42: '0110217',
        43: '0110218',
        44: '0110219',
        28: '0110215',
        45: '0110220',
        46: '0110221',
        47: '0110222',
        48: '0110223',
        49: '0110224',
        50: '0110225',
        51: '0080006',
        52: '0110226',
        56: '0110231',
        59: '0110235',
        70: '0110237',
        66: '0110238',
        57: '0110233',
        58: '0110234',
        60: '0110236',
        71: '0110239'
      }
      return map[row.type]
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
